import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { Spotlight, Card as ArticleCard } from '../articles/card';
import ToggleButton from './section-type/toggle-button';

const Section = ({
  children,
  className,
  color,
  type,
  issue,
  lazyLoad,
  spotlightPosts = [],
  restPosts = [],
  expandButtonLocation = 'afterRestPosts',
  panel = false,
}) => {
  const thisSection = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const onExpandPosts = () => {
    setExpanded((prevExpanded) => !prevExpanded);

    const headerHeight = document.querySelector('.site-header').getBoundingClientRect().height;
    const currentSection = thisSection.current.getBoundingClientRect();

    if (expanded) {
      window.scrollTo({
        top: currentSection.top + window.pageYOffset - headerHeight,
        behavior: 'smooth',
      });
    }
  };
  const expandButton = (
    <ToggleButton
      issue={issue}
      type={type}
      expanded={expanded}
      onExpandPosts={onExpandPosts}
      key={issue.slug}
    />
  );

  const spotlightElem = (
    <>
      {!!spotlightPosts.length && (
        <aside className={`${type}-issue-grid__spotlight`}>
          <Spotlight post={spotlightPosts[0]} issue={issue} type="feature" lazyLoad={lazyLoad} />
        </aside>
      )}
    </>
  );

  const restPostsElem = (
    <>
      {!!restPosts.length && (
        <div className={`${type}-issue-grid__posts`}>
          {restPosts.map((post) => (
            <ArticleCard post={post} key={post.slug} />
          ))}
        </div>
      )}
    </>
  );

  const childrenParts = {
    beforeRestPosts: [],
    afterRestPosts: [],
    beforePanel: [],
    afterPanel: [],
  };

  if (children) {
    React.Children.forEach(children, (child, index) => {
      if (React.isValidElement(child)) {
        const clonedChild = React.cloneElement(
          child,
          { key: index, position: null },
          child.props.children,
        );

        if (child.props.position && typeof childrenParts[child.props.position] === 'object') {
          childrenParts[child.props.position].push(clonedChild);
        } else {
          childrenParts.afterRestPosts.push(clonedChild);
        }
      }
    });
  }

  if (expandButtonLocation && typeof childrenParts[expandButtonLocation] === 'object') {
    childrenParts[expandButtonLocation].push(expandButton);
  }

  return (
    <section
      className={classNames([
        className,
        `${type}-issue-grid`,
        'issue-section',
        color && `${type}-issue-grid--color-${color}`,
        expanded && `${type}-issue-grid--expanded`,
      ])}
      ref={thisSection}
    >
      {spotlightElem}
      {!panel && (
        <>
          {childrenParts.beforeRestPosts}
          {restPostsElem}
          {childrenParts.afterRestPosts}
        </>
      )}
      {!!panel && (
        <>
          {childrenParts.beforePanel}
          <div className={`${type}-issue-grid__panel issue-section__panel`}>
            {childrenParts.beforeRestPosts}
            {restPostsElem}
            {childrenParts.afterRestPosts}
          </div>
          {childrenParts.afterPanel}
        </>
      )}
    </section>
  );
};

export default Section;
